export const CANCEL_PENDING = 'pending'
export const CANCEL_DONE = 'cancelled'

export const isCancelledShipment = (shipment) => {
  if (!shipment) return false
  if (shipment.status === 'Rejected' || shipment.cancel_status === CANCEL_DONE) return true
  return Boolean(shipment.is_cancelled)
}

export const isCancelPending = (shipment) => {
  if (!shipment || isCancelledShipment(shipment)) return false
  if (shipment.cancel_status === CANCEL_PENDING) return true
  return Boolean(shipment.is_cancel_pending)
}

export const displayShipmentStatus = (shipment) => {
  if (isCancelledShipment(shipment)) return 'Cancelled'
  if (isCancelPending(shipment)) return 'Cancel pending'
  return shipment?.status || ''
}

export const cancelledByLabel = (shipment) => {
  if (!shipment) return '—'
  return (
    shipment.cancelled_by_display ||
    shipment.cancelled_by_name ||
    shipment.cancelled_by ||
    '—'
  )
}

export const cancelRequestedByLabel = (shipment) => {
  if (!shipment) return '—'
  return (
    shipment.cancel_requested_by_display ||
    shipment.cancel_requested_by_name ||
    shipment.cancel_requested_by ||
    '—'
  )
}
